const muiCustomStyles = {
  formControl: {
    width: "100%",
    "& .MuiAutocomplete-popper": {
      marginTop: "8px !important",
    },
    "& .MuiPaper-root": {
      borderRadius: "8px",
    },
    "& .MuiAutocomplete-listbox": {
      maxHeight: "100px",
    },
  },

  autocomplete: {
    width: "100%",
    borderRadius: "8px",
    backgroundColor: "#fff",
    "& .MuiInputBase-root": {
      flexWrap: "nowrap !important",
      padding: "3px 9px !important",
      height: "39px",
      borderRadius: "8px",
      fontSize: "15px",
    },
    "& .MuiAutocomplete-clearIndicator": {
      display: "none",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        border: "1px solid rgba(230, 228, 235, 1)",
      },
      "&:hover fieldset": {
        borderColor: "rgba(36, 139, 112, 1)",
      },
      "&.Mui-focused fieldset": {
        borderColor: "rgba(36, 139, 112, 1)",
      },
      "&.Mui-disabled fieldset": {
        borderColor: "rgba(230, 228, 235, 1)",
      },
      "&.Mui-disabled:hover fieldset": {
        borderColor: "rgba(230, 228, 235, 1)",
      },
    },
  },

  menuItem: {
    padding: "0px 12px",
    borderRadius: "4px",
    mb: "12px",
    "&.Mui-selected": {
      backgroundColor: "rgba(0, 0, 0, 0.05)",
      "&:hover": {
        backgroundColor: "rgba(0, 0, 0, 0.05)",
      },
    },
  },

  menuItemText: {
    fontSize: "15px",
    fontWeight: 400,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
};

export default muiCustomStyles;
